// What each File label means: the one text its hover on the company page and
// the Definitions page both show (Dhanur, 25 Oct 2026), so the two never
// drift. Each says what the value is, what it counts and what higher means,
// in the buyer's words: no method, no opinion, no internal terms.

export const metricDefinitions: Record<string, string> = {
  "Aggregate Rating":
    "The average star rating, out of 5, of all the company's reviews across the review sites Night Shift tracks.",
  "Total Reviews":
    "How many reviews the company has across the review sites Night Shift tracks.",
  "12-Mo Review Avg":
    "How many reviews the company received per month, on average, over the last 12 months.",
  "vs Prior 12-Mo":
    "The change in reviews per month over the last 12 months, compared with the 12 months before. Positive means more reviews.",
  "Buyer Rate":
    "Of the reviews that say whether the writer hired the company, the share written by people who did, not people who only got a quote.",
  "Buyer Satisfaction":
    "The share of satisfied reviews among people who hired the company.",
  "Long-Term Review Rate":
    "Of the reviews that say how long the writer has been a customer, the share from customers of 12 months or more.",
  "Long-Term Satisfaction":
    "The share of satisfied reviews among customers of 12 months or more, who have lived with the system.",
  "Deception Rate":
    "The share of reviews that describe deceptive sales, such as misleading quotes, bait-and-switch or broken promises about price or savings. Lower is better.",
  "Sales Conduct":
    "Of the reviews that discuss the sales process, the share satisfied with it: honesty, pressure and follow-through.",
  Workmanship:
    "Of the reviews that discuss the installation itself, the share satisfied with it: panel placement, wiring, roof work and code compliance.",
  Value:
    "Of the reviews that discuss value, the share that felt the result was worth what they paid. This is fairness, not price level.",
  "Customer Support":
    "Of the reviews that discuss support after installation, the share satisfied with it: responsiveness, warranty claims and maintenance.",
  "Project Management":
    "Of the reviews that discuss how the project ran, the share satisfied with it: timelines, crews, permits and inspections.",
  Roofing:
    "The share of the company's reviews that mention roofing work, and the share of those that are satisfied.",
  Storage:
    "The share of the company's reviews that mention battery storage work, and the share of those that are satisfied.",
  Electrical:
    "The share of the company's reviews that mention electrical work, and the share of those that are satisfied.",
  HVAC: "The share of the company's reviews that mention HVAC work, and the share of those that are satisfied.",
  "Services Marketed":
    "The services the company advertises, whether or not its reviews mention them.",
}

export const sectionDefinitions: Record<string, string> = {
  Reviews:
    "The company's public star rating and review counts across the review sites Night Shift tracks.",
  Character:
    "Who reviews the company, how satisfied its customers stay over time, and how often they describe deceptive sales.",
  Execution:
    "How satisfied customers are with each stage of the work, from the sale through installation and support.",
  "Trade Mix":
    "How much of the company's work is roofing, storage, electrical or HVAC, judged from its own reviews, and how satisfied those customers are. A dash means too few of its reviews mention that work; the download writes “Insufficient Data”, or “0% share” when none do.",
  Background:
    "Who the company is and the contractor licenses it holds, as public records state them.",
}
